import {SELECT_SHEET} from '../lib/constants';

export default function selectSheet(name) {
    return {
        type: SELECT_SHEET,
        selected: name
    }
}